import { apiPost } from '.';
import {
  KafkaLoggerFilters,
  KafkaMessage,
  OutgoigMessagePayload,
  KafkaOutgoingMessagesFilters,
} from '@go-shared/types/kafkaLogs';

export const getFilteredKafkaLogs = async (filters: KafkaLoggerFilters) => {
  return apiPost<{ logs: KafkaMessage[] }>('/kafka-logs', filters);
};

export const getKafkaOutgoingMessages = async (filters?: KafkaOutgoingMessagesFilters) => {
  return apiPost<{ messages: OutgoigMessagePayload[] }>('/kafka-outgoing-messages', filters);
};
